import React, { useEffect, useState } from "react";
import ProductCard from "../../../Hook/Pc"; // même composant
import { useNavigate } from "react-router-dom";
import "../Ordinateur.css";

const Nas = () => {
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);

    useEffect(() => {
        fetch("https://www.amservices.eu/api/products_nas.php")
            .then(res => res.json())
            .then(data => setProducts(Array.isArray(data) ? data : []))
            .catch(console.error);
    }, []);

    return (
        <>
            <h1 className="sr-only">Solutions NAS professionnels</h1>
            <h2 className="section-title">Nos NAS</h2>

            <div className="product-list">
                {products.map(product => {
                    // Construire la description multi-lignes
                    const description = (product.specs || [])
                        .map(s => s.label + (s.stars ? " " + "⭐".repeat(Number(s.stars)) : ""))
                        .join("\n");

                    return (
                        <div key={product.id} className="product-with-toggle Nas">
                            <ProductCard
                                img={`https://www.amservices.eu/api/${product.logo}`}
                                alt={product.title}
                                title={product.title}
                                specs={[]}             // vide pour NAS
                                optionText=""          // pas d'option pro
                                description={description}  // chaque spec sur sa ligne
                            />
                        </div>
                    );
                })}
            </div>
            <div className='div_btn-retour'>
                <div className="btn-telephones" onClick={() => navigate("/ordinateur")}>
                    Retour
                </div>
            </div>
        </>
    );
};

export default Nas;
